import gsap from 'gsap';
import getQueryParameter from './getQueryParameter';
import { setTags } from './SCORM';
import findTopWindow from './findTopWindow';
import { debounce } from 'lodash-es';

const turbo = getQueryParameter('turbo');

const trackScroll = e => {
  const editorWindow = findTopWindow({
    withOpeners: true,
    predicate: w => 'setLatestScroll' in w
  });

  const shouldSetScroll =
    e.target.matches &&
    e.target.matches('.scroller') &&
    editorWindow?.setLatestScroll;

  if (shouldSetScroll) editorWindow.setLatestScroll(e.target.scrollTop);
};

window.addEventListener(
  'scroll',
  debounce(trackScroll, 3000, { leading: false }),
  { capture: true }
);

/**
 * DEV HMR UPDATE LOGIC
 */
if (import.meta.env.DEV && import.meta.hot) {
  if (getQueryParameter('word')) {
    gsap.globalTimeline.timeScale(1e6);
  } else if (turbo) {
    gsap.globalTimeline.timeScale(turbo);
  }

  window.addEventListener(
    'scroll',
    e => {
      if (e.target.matches && e.target.matches('.scroller')) {
        import.meta.hot.data.latestScroll = e.target.scrollTop;
      }
    },
    { capture: true }
  );

  // window.addEventListener('uc:hmrstarting', e => console.log('uc:hmrstarting'));
  // window.addEventListener('uc:hmrstarted', e => console.log('uc:hmrstarted'));
  // window.addEventListener('uc:hmrending', e => console.log('uc:hmrending'));
  // window.addEventListener('uc:hmrended', e => console.log('uc:hmrended'));

  import.meta.hot.on('vite:beforeUpdate', async function beforeUpdate() {
    /**
     * enter update mode
     */
    window.dispatchEvent(new CustomEvent('uc:hmrstarting'));
    document.documentElement.classList.add('-hmr-updating');
    window.__hmr_updating = true;
    gsap.globalTimeline.timeScale(1e6);

    window.dispatchEvent(new CustomEvent('uc:hmrstarted'));

    /**
     * wait for the current page to leave
     */
    let i = 99;
    let container = document.querySelector('.scroller');
    const latestScroll = import.meta.hot.data.latestScroll;

    if (container) {
      while (i-- && container?.isConnected) {
        await new Promise(r => window.requestAnimationFrame(r));
      }

      // console.log({ latestScroll, container, i });

      /**
       * wait for new page to enter
       */
      i = 0;
      container = null;

      while (i++ < 200 && !container) {
        await new Promise(r => window.requestAnimationFrame(r));
        container = document.querySelector('.scroller');
      }

      // console.log({ latestScroll, container, i });

      /**
       * restore scroll
       */
      container.scrollTo(0, latestScroll || 0);
    }

    /**
     * exit update mode
     */
    window.dispatchEvent(new CustomEvent('uc:hmrending'));

    setTags();
    await new Promise(r => setTimeout(r, 150));
    document.documentElement.classList.remove('-hmr-updating');
    window.__hmr_updating = false;
    if (turbo) gsap.globalTimeline.timeScale(turbo);

    window.dispatchEvent(new CustomEvent('uc:hmrended'));
  });
}
